module.exports = __webpack_public_path__ + "img/jovenes11.eddac1d6.webp";